import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseBoolean, parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export interface FailureProbability {
  failureProbability: number
  failureType?: string
  startYear?: string
  endYear?: string
}

export class GeckoAssetHealthPlan extends GeckoEntryBase<
  {
    name: string
    preferred: boolean
    created_time: number
    failureProbabilities?: FailureProbability[]
    predictedRisk?: number
    predictedRiskClass?: string
    predictedLikelihood?: number
    predictedConsequence?: number
  },
  {
    organization: string
    site: string
    unit: string
    [RolodexEntryType.VISUAL_INSPECTION_FORM_RESPONSE]?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        name: parseString(json.data.name) ?? 'Unnamed Health Plan',
        preferred: parseBoolean(json.data.preferred) ?? false,
        created_time: parseNumber(json.data.created_time) ?? Date.now(),
        failureProbabilities: json.data.failureProbabilities as
          | FailureProbability[]
          | undefined,
        predictedRisk: parseNumber(json.data.predictedRisk),
        predictedRiskClass: parseString(json.data.predictedRiskClass),
        predictedLikelihood: parseNumber(json.data.predictedLikelihood),
        predictedConsequence: parseNumber(json.data.predictedConsequence),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit) ?? '',
        [RolodexEntryType.VISUAL_INSPECTION_FORM_RESPONSE]: parseString(
          json.tags[RolodexEntryType.VISUAL_INSPECTION_FORM_RESPONSE]
        ),
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoAssetHealthPlan(json)
  }
}
